import useFeatureFlags from '../useFeatureFlags';

// create function to consume launchDarkly hook to force update version
declare const window: any;

// add same decimal places to lastVersion and clientVersion
// lastVersion = 1.28.46 => 12846
// clientVersion = 1.29.1 => 12901
function formatVersion(version: string) {
  // Split the version into parts
  const parts = version.split('.');

  // Pad each part with zeros to ensure they have two digits
  const paddedParts = parts.map((part) => part.padStart(2, '0'));

  // Join the parts back together
  const formattedVersion = paddedParts.join('');

  return Number.parseInt(formattedVersion, 10);
}

const useUpdateVersion = (): boolean => {
  const flags = useFeatureFlags();

  const lastVersion = formatVersion(flags.forceUpdateVersion);
  const clientVersion = formatVersion(window.__DASHBOARD_MONOREPO_VERSION__);

  const isLocalhost = window.location.hostname.includes('localhost');
  const isPreview = window.location.hostname.includes('preview');
  const isDev = isLocalhost || isPreview;

  // not force update version if is dev
  if (isDev) return false;

  // accept if client version is greater than last version
  if (clientVersion >= lastVersion) return false;

  // force refresh browser to update version
  window.location.reload();

  return true;
};

export default useUpdateVersion;
